export default __webpack_public_path__ + "static/media/giphy.34998c56.gif";